import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { Provider } from "react-redux";
import { store } from "./storeRedux/store";
import { LangProvider } from "./context/Lang";

import { PrimeReactProvider } from "primereact/api";
import Tailwind from 'primereact/passthrough/tailwind';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import { App } from "./App";


const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

axios.defaults.baseURL = process.env.REACT_APP_API_URL;


root.render(<Provider store={store} >
    <LangProvider>
        <div className="  w-screen text-sm  " >
            <PrimeReactProvider value={{ 
                unstyled: true, 
                pt: Tailwind, 
                zIndex: { 
                    modal:1,  
                    overlay: 1,
                    menu: 1,
                    tooltip: 1,
                    toast: 1
                }  
            }}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </PrimeReactProvider>
        </div>
    </LangProvider>
</Provider>)